<div class="modal-header">
    <h3 class="modal-title">Update Vendor</h3>
</div>
<div class="modal-body">
    <div class="row" *ngIf="alert">
        <div class="col-12">
            <div class="alert" [ngClass]="{'alert-success' : alert.type === 'success', 'alert-default' : alert.type === 'default', 'alert-danger': alert.type === 'danger' }" role="alert">
                {{alert.msg}}
            </div>
        </div>
    </div>
    <ng-select [items]="prGroupObservables.prGroup$ | async"
               [typeahead]="prGroupObservables.prGroupInput$"
               bindLabel="VendorFullName"
               typeToSearchText="Please enter 2 or more characters"
               placeholder="Type to search..."
               [clearable]="true"
               [(ngModel)]="selectedPRGroup.Value">
    </ng-select>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()">Cancel</button>
    <button type="button" class="btn btn-success" (click)="saveClicked()">Save</button>
</div>